import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'

export const DashboardConsultantCardEmptyState = () => {
    const {t} = useTranslation()

    return (
        <Flexbox direction="column" gap={2} fullWidth align="center" justify="center" style={{padding: '24px'}}>
            <Text palette="neutral" shade="700" size="textLg" weight={600}>
                {t('accesses:no_consultant_selected')}
            </Text>
            <Text palette="neutral" shade="500" size="textSm">
                {t('accesses:no_consultant_selected_description')}
            </Text>
        </Flexbox>
    )
}
